import { render, staticRenderFns } from "./manageEventPoints.vue?vue&type=template&id=71e21abf"
import script from "./manageEventPoints.vue?vue&type=script&lang=js"
export * from "./manageEventPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports